import { tDiscountPercent } from "../../interfaces";
import { tDispatch } from "../store";
import { eUIActionTypes } from "./UITypes";

export const clearUIstate = () => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eUIActionTypes.CLEAR_STATE,
		})
	}
}

export const setIsDepositAvailable = (percent: tDiscountPercent, state: boolean) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eUIActionTypes.SET_IS_DEPOSIT_AVAILABLE,
			payload: {
				percent,
				state
			}
		})
	}
}